import * as focusTrap from 'focus-trap';
import { hide as hideOverlay, show as showOverlay, create as createOverlay } from '../lib/overlay';

class Openable {
  constructor(element, overlay = false) {
    this.isActive = false;

    if (typeof element === 'string' || element instanceof String) {
      this.container = document.querySelector(element);
    } else {
      this.container = element;
    }

    this.overlay = overlay;
    this.container.hidden = true;
    this.setState(false);

    this.focusTrap = focusTrap.createFocusTrap(this.container, {
      allowOutsideClick: true,
    });

    if (this.overlay) {
      createOverlay(this.overlay);
    }

    this.clickEvent = this.clickEvent.bind(this);
    this.keydownEvent = this.keydownEvent.bind(this);
    this.addEventListeners = this.addEventListeners.bind(this);
  }

  addEventListeners() {
    document.addEventListener('click', this.clickEvent);
    document.addEventListener('keydown', this.keydownEvent);
    this.focusTrap.activate();
  }

  removeEventListeners() {
    document.removeEventListener('click', this.clickEvent);
    document.removeEventListener('keydown', this.keydownEvent);
    this.focusTrap.deactivate();
  }

  clickEvent(event) {
    if ( event.target.hasAttribute('data-close') ) {
      event.stopPropagation();
      this.close();
    }
  }

  keydownEvent(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  setState(state) {
    this.isActive = state;
    this.container.setAttribute('aria-hidden', state ? 'false' : 'true');

    this.container.dispatchEvent(new CustomEvent('openable:state', {
      detail: { state }
    }));
  }

  toggle() {
    if (this.isActive) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.setState(true);
    this.container.hidden = false;

    setTimeout(() => {
      this.container.classList.add(this.classes.active);
      showOverlay(this.overlay);

      this.addEventListeners();
    }, 1);
  }

  close() {
    this.setState(false);

    this.container.classList.remove(this.classes.active);
    hideOverlay(this.overlay);

    this.removeEventListeners();

    this.container.addEventListener('transitionend', () => {
      this.container.hidden = true;
    }, { once: true });
  }
}

export default Openable;